import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  OnDestroy,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TiktokCreatorEmbedComponent } from '../components/tiktok-creator-embed/tiktok-creator-embed.component';
import {
  TikTokCarouselComponent,
  TikTokItem,
} from './../components/tik-tok-carousel/tik-tok-carousel.component';
import { FooterComponent } from '../shared/footer/footer.component';

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqCategory {
  name: string;
  items: FaqItem[];
}

@Component({
  selector: 'app-cliente',
  imports: [FormsModule, TikTokCarouselComponent, FooterComponent],
  templateUrl: './cliente.component.html',
  styleUrl: './cliente.component.scss',
})
export class ClienteComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('benefitCard') benefitCards!: QueryList<ElementRef>;
  @ViewChildren('stepCard') stepCards!: QueryList<ElementRef>;
  @ViewChildren('animatedElement') animatedElements!: QueryList<ElementRef>;
  @ViewChild('parallaxBg') parallaxBg!: ElementRef;
  @ViewChild('parallaxCopy') parallaxCopy!: ElementRef;
  @ViewChild('parallaxHero') parallaxHero!: ElementRef;
  private observer: IntersectionObserver | undefined;
  private mouseX = 0;
  private mouseY = 0;
  private scrollY = 0;

  isMenuOpen = false;
  simuladorMonto = '';
  simuladorPlazo = 16;
  pagoSemanal = 0;
  pagoTotal = 0;
  pagoSemanalTexto = '$0';
  pagoTotalTexto = '$0';
  readonly minValorSimulador = 5000;
  readonly maxValorSimulador = 60000;
  readonly plazos = [
    { name: '16 semanas', code: 16 },
  ];
  private montoDigits = '0';
  tiktoks: TikTokItem[] = [
     {
    link: 'https://www.tiktok.com/@teu.mx/video/7619090687971052808',
    img: 'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-4863-sg/o0fZcjIQ3BBiCdXEAIXq1rESb4lgq07OBve8iG~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=uUT4XMHrG9Bci1hEyQCG8x6WJ98%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  {
    link: 'https://www.tiktok.com/@teu.mx/video/7616446698021211393',
    img: 'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-4863-sg/o8YgDMQQBIKiPzzOCoiBuxfIxAPHaJAEiXwdXb~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=9nQGyVpuJdLdrTCN4buKV0ueCO8%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  {
    link: 'https://www.tiktok.com/@teu.mx/video/7613897498511428882',
    img: 'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-4863-sg/oQ3pI8FvYNw3vODTGCDSQ9U879TAfFlfmfE8fk~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=k7euSgfNwGBIs54sbM64PdWCcfc%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  {
    link: 'https://www.tiktok.com/@teu.mx/video/7610927467993271572',
    img: 'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-4863-sg/oIu7WPIk77EU7fwjflR3clAIGeSXLGCdeFQTuQ~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=5K7IvpH5WR5p6mGqEw30uO%2FDB4I%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  {
    link: 'https://www.tiktok.com/@teu.mx/video/7608282810800966920',
    img: 'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-4863-sg/oMciLvB7EieciZGzdf8bWIwY0O7DCBzTyBigEB~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=5cwqdKV%2Bn%2BFVtO%2FyLnNlLxO44Lc%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  {
    link: 'https://www.tiktok.com/@teu.mx/video/7606056560678194452',
    img: 'https://p16-sign-sg.tiktokcdn.com/tos-alisg-p-4863-sg/oIE0O02v7BxGAge29HIE2iiBIJBF5xBswfCTCc~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=IXSbBkUauE5ZPR%2BZKn2ZOlWT4r8%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  {
    link: 'https://www.tiktok.com/@teu.mx/video/7600889347449097484',
    img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/ow5vSE6QCIUmYBSlzsNKcBSiBXDvaMyuiUzA7~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=jGUec8%2BWRtVXqNLsql42%2FgL%2FnuI%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  {
    link: 'https://www.tiktok.com/@teu.mx/video/7599791711174298936',
    img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oIEB3i01IdxGB50uBftBf9w8QJioBZhI1pAMEU~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=obRzsYowoOXPISfricV5TIGLLpM%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  {
    link: 'https://www.tiktok.com/@teu.mx/video/7598278839193718027',
    img: 'https://p16-sign-va.tiktokcdn.com/tos-maliva-p-85c255/oklXLPMAErisQ5yMG8CgmCiSBXBU1K9BZIaUD~tplv-tiktokx-origin.image?dr=14575&x-expires=1774447200&x-signature=PB%2BJMQiTsMSGgxN5FPoA5lFqO4k%3D&t=4d5b0474&ps=13740610&shp=81f88b70&shcp=43f4a2f9&idc=my2'
  },
  ];

  faqCategories: FaqCategory[] = [
    {
      name: 'Sobre Teu y Seguridad',
      items: [
        {
          question: '¿Qué es Teu y cómo funciona?',
          answer:
            'Teu es tu aliado financiero. Ofrecemos créditos accesibles diseñados para personas y grupos que buscan crecer. Funcionamos de manera digital y cercana: solicitas tu crédito, recibes la aprobación rápida y gestionas todo desde tu celular o con el apoyo de nuestros promotores.',
        },
        {
          question: '¿Es seguro compartir mi información con Teu?',
          answer:
            'Totalmente. En Teu utilizamos tecnología de seguridad bancaria para proteger tus datos personales y financieros. Tu información es confidencial y solo se utiliza para gestionar tu crédito de manera segura. Para tu tranquilidad, en caso de que la solicitud no sea autorizada o el proceso se cancele, borramos todos tus datos de nuestros sistemas bajo estrictos protocolos de seguridad.',
        },
        {
          question: '¿Por qué me conviene obtener un crédito con Teu?',
          answer:
            'Porque nos enfocamos en la confianza. Ofrecemos respuesta rápida, trámites sin complicaciones y beneficios exclusivos como el perdón de intereses moratorios en campañas especiales y recompensas por pago puntual.',
        },
        {
          question: '¿Para qué necesitan mis datos si solo quiero hacer una pregunta?',
          answer:
            'Tus datos nos permiten localizar tu perfil en nuestro sistema de forma inmediata. De esta manera, podemos brindarte información exacta sobre tu crédito y resolver tus dudas de manera personalizada y segura.',
        },
      ],
    },
    {
      name: 'Mi Crédito (Solicitud y Pagos)',
      items: [
        {
          question: '¿Cuáles son los requisitos para obtener mi primer crédito?',
          answer:
            'Es muy sencillo. Solo necesitas ser mayor de edad, contar con una identificación oficial vigente (INE), comprobante de domicilio y completar nuestra solicitud básica. ¡No pedimos trámites imposibles!',
        },
        {
          question: '¿Cuánto tiempo tarda en autorizarse mi crédito?',
          answer:
            'Sabemos que el tiempo es dinero. Una vez que entregas tu documentación completa, nuestro equipo revisa la solicitud y recibes una respuesta en un plazo de 24 horas.',
        },
        {
          question: '¿Cómo puedo consultar mi monto para liquidar y mi referencia de pago?',
          answer:
            'Puedes consultarlo con tu promotor asignado o al instante enviando un mensaje a nuestro WhatsApp oficial de soporte 56 4250 6626. Ahí te proporcionaremos tu saldo actual (solo aplica para créditos individuales) y tu número de referencia único para que pagues en el banco o tienda de conveniencia de tu preferencia.',
        },
        {
          question: '¿Qué pasa si me atraso en un pago y qué gano por pagar a tiempo?',
          answer:
            'Pagar a tiempo te ayuda a mantener un historial sano y te da acceso a montos mayores en tu renovación. Si te atrasas, se generan intereses moratorios, pero siempre puedes contactar a tu asesor para buscar una solución antes de que tu deuda crezca.',
        },
        {
          question: 'He enviado mi solicitud pero no he recibido noticias, ¿por qué no me han dado seguimiento?',
          answer:
            '¡No te preocupes! Generalmente, esto sucede por tres razones: estamos validando tu documentación, hubo un error en los datos de contacto o estamos procesando un alto volumen de solicitudes. Si han pasado más de 72 horas hábiles y no tienes noticias, por favor escríbenos directamente por WhatsApp para darte una respuesta.',
        },
      ],
    },
    {
      name: 'Renovaciones y Promotores',
      items: [
        {
          question: '¡Ya terminé de pagar! ¿Cómo renuevo mi crédito?',
          answer:
            '¡Felicidades! Si mantuviste un buen historial, tu renovación es casi automática. Tu promotor se pondrá en contacto contigo o tú mismo puedes solicitarla desde nuestro WhatsApp de atención para recibir tu nuevo desembolso.',
        },
        {
          question: '¿Puedo renovar mi crédito con un promotor diferente?',
          answer:
            'Sí. Si prefieres cambiar de promotor para tu siguiente ciclo, por favor contacta a nuestro equipo de Soporte Central para que asignemos a una nueva persona que te brinde la atención que mereces.',
        },
        {
          question: '¿Cómo puedo poner una queja sobre el servicio de mi promotor?',
          answer:
            'Tu satisfacción es lo más importante. Si tuviste un mal servicio, envía un mensaje con la palabra "QUEJA" a nuestro WhatsApp oficial o al correo soporte@teu.mx. Tu reporte será anónimo y nos ayudará a mejorar nuestro servicio de inmediato.',
        },
      ],
    },
    {
      name: 'Contacto y Talento',
      items: [
        {
          question: '¿Cómo puedo contactar al personal de soporte de Teu?',
          answer:
            'Estamos para servirte. Puedes escribirnos por WhatsApp al 56 4250 6626 de lunes a viernes de 8:00 a.m. a 5:00 p.m. También puedes seguir nuestras redes sociales oficiales.',
        },
        {
          question: 'Me interesa trabajar en Teu, ¿cómo le hago?',
          answer:
            '¡Nos encanta que quieras unirte a la familia Teu! Envía tu currículum o una descripción de tu experiencia al correo vacantes@teu.mx o pregunta por nuestras vacantes vigentes en nuestro chat de soporte.',
        },
      ],
    },
  ];

  openCategoryIndex: number | null = 0;
  openFaqIndex: { categoryIndex: number; itemIndex: number } | null = {
    categoryIndex: 0,
    itemIndex: 0,
  };
  footerColorClass = 'footer-cliente';

  ngOnInit(): void {
    this.montoDigits = '0';
    this.simuladorMonto = this.formatCurrency(0);
    this.calcular();
  }

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target as HTMLElement;
            
            // Add 'active' class to trigger reveal animation
            element.classList.add('active');

            // Remove legacy hidden classes if present
            element.classList.remove(
              'hidden-benefit',
              'hidden-step',
              'hidden-animate'
            );
            
            observer.unobserve(element);
          }
        });
      },
      { threshold: 0.1 }
    );

    this.benefitCards.forEach((card) => {
      this.observer?.observe(card.nativeElement);
    });

    this.stepCards.forEach((card) => {
      this.observer?.observe(card.nativeElement);
    });

    this.animatedElements.forEach((el) => {
      this.observer?.observe(el.nativeElement);
    });
  }

  animateOnHover(event: MouseEvent): void {
    const element = event.currentTarget as HTMLElement;
    if (element.classList.contains('animate__heartBeat')) return;

    // element.classList.remove('animate__fadeInUp'); // No longer needed
    element.style.animationDelay = '0s'; // Clear delay for hover effect

    element.classList.add('animate__animated', 'animate__heartBeat');
    element.addEventListener(
      'animationend',
      () => {
        element.classList.remove('animate__heartBeat', 'animate__animated');
        element.style.animationDelay = ''; 
      },
      { once: true }
    );
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.scrollY = window.scrollY;
    this.updateParallax();
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    this.mouseX = (event.clientX / window.innerWidth - 0.5) * 2; // -1 to 1
    this.mouseY = (event.clientY / window.innerHeight - 0.5) * 2; // -1 to 1
    //this.updateParallax();
  }

  private updateParallax(): void {
    /*if (this.parallaxBg) {
      // Fondo: se mueve con scroll (lento) y mouse (opuesto al mouse)
      const moveX = this.mouseX * -20; // max 20px
      const moveY = this.scrollY * 0.4 + this.mouseY * -20;
      this.parallaxBg.nativeElement.style.transform = `translate3d(${moveX}px, ${moveY}px, 0)`;
    }*/

    /*if (this.parallaxCopy) {
      // Copy: se mueve con scroll (medio) y mouse (ligero)
      const moveX = this.mouseX * 10;
      const moveY = this.scrollY * 0.2 + this.mouseY * 10;
      this.parallaxCopy.nativeElement.style.transform = `translate3d(${moveX}px, ${moveY}px, 0)`;
    }*/

    if (this.parallaxHero) {
      // Hero: se mueve con scroll (casi normal) y mouse (más fuerte)
      const moveX = this.mouseX * 30;
      const moveY = this.scrollY * 0.1 + this.mouseY * 30;
      this.parallaxHero.nativeElement.style.transform = `translate3d(${moveX}px, ${moveY}px, 0)`;
    }
  }

  toggleCategory(index: number): void {
    this.openCategoryIndex = this.openCategoryIndex === index ? null : index;
  }

  toggleFaq(categoryIndex: number, itemIndex: number): void {
    if (
      this.openFaqIndex &&
      this.openFaqIndex.categoryIndex === categoryIndex &&
      this.openFaqIndex.itemIndex === itemIndex
    ) {
      this.openFaqIndex = null;
    } else {
      this.openFaqIndex = { categoryIndex, itemIndex };
    }
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  private parseCurrency(value: string): number {
    const limpio = value.replace(/[^0-9.]/g, '');
    const numero = parseFloat(limpio);
    if (!isFinite(numero) || numero < 0) {
      return 0;
    }
    return numero;
  }

  private formatCurrency(value: number): string {
    return value.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  private parseCurrencyInput(value: string): number {
    const digits = value.replace(/\D+/g, '');
    const numero = digits ? Number(digits) : 0;
    if (!Number.isFinite(numero) || numero < 0) {
      return 0;
    }
    return numero;
  }

  private setCaretByDigitCount(
    input: HTMLInputElement,
    formattedValue: string,
    digitsBeforeCaret: number
  ): void {
    if (!input.setSelectionRange) return;
    if (digitsBeforeCaret <= 0) {
      input.setSelectionRange(0, 0);
      return;
    }

    let seenDigits = 0;
    for (let i = 0; i < formattedValue.length; i++) {
      if (/\d/.test(formattedValue[i])) {
        seenDigits += 1;
        if (seenDigits >= digitsBeforeCaret) {
          const caretPos = i + 1;
          input.setSelectionRange(caretPos, caretPos);
          return;
        }
      }
    }

    const end = formattedValue.length;
    input.setSelectionRange(end, end);
  }

  private setCaretBeforeDecimals(input: HTMLInputElement, formattedValue: string): void {
    if (!input.setSelectionRange) return;
    const decimalIndex = formattedValue.lastIndexOf('.');
    const caretPos = decimalIndex >= 0 ? decimalIndex : formattedValue.length;
    input.setSelectionRange(caretPos, caretPos);
  }

  private syncMontoInput(input: HTMLInputElement): void {
    const value = input.value || '';
    const digits = value.replace(/\D+/g, '') || '0';
    let numeric = Number(digits);
    if (!Number.isFinite(numeric) || numeric < 0) numeric = 0;
    if (numeric > this.maxValorSimulador) numeric = this.maxValorSimulador;
    this.montoDigits = String(Math.trunc(numeric));

    const formatted = this.formatCurrency(Number(this.montoDigits));
    this.simuladorMonto = formatted;
    input.value = formatted;
    this.setCaretBeforeDecimals(input, formatted);
  }

  onMontoFocus(event: FocusEvent): void {
    const target = event.target as HTMLInputElement;
    this.montoDigits = '0';
    const formatted = this.formatCurrency(0);
    this.simuladorMonto = formatted;
    target.value = formatted;
    this.setCaretBeforeDecimals(target, formatted);
    this.calcular();
  }

  onMontoInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.syncMontoInput(target);
    this.calcular();
  }

  onMontoKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    if (/^\d$/.test(key)) {
      event.preventDefault();
      if (this.montoDigits === '0') {
        this.montoDigits = key;
      } else {
        this.montoDigits = `${this.montoDigits}${key}`;
      }
      let numeric = Number(this.montoDigits);
      if (!Number.isFinite(numeric) || numeric < 0) numeric = 0;
      if (numeric > this.maxValorSimulador) numeric = this.maxValorSimulador;
      this.montoDigits = String(Math.trunc(numeric));

      const formatted = this.formatCurrency(Number(this.montoDigits));
      this.simuladorMonto = formatted;
      input.value = formatted;
      this.setCaretBeforeDecimals(input, formatted);
      this.calcular();
      return;
    }

    if (key === 'Backspace' || key === 'Delete') {
      event.preventDefault();
      if (this.montoDigits.length <= 1) {
        this.montoDigits = '0';
      } else {
        this.montoDigits = this.montoDigits.slice(0, -1);
      }
      const formatted = this.formatCurrency(Number(this.montoDigits));
      this.simuladorMonto = formatted;
      input.value = formatted;
      this.setCaretBeforeDecimals(input, formatted);
      this.calcular();
    }
  }

  onMontoBlur(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.syncMontoInput(target);
    const monto = Number(this.montoDigits);
    if (monto > 0 && monto < this.minValorSimulador) {
      this.montoDigits = String(this.minValorSimulador);
      const formatted = this.formatCurrency(this.minValorSimulador);
      this.simuladorMonto = formatted;
      target.value = formatted;
      this.setCaretBeforeDecimals(target, formatted);
    }
    this.calcular();
  }

  onPlazoChange(plazo: number | string): void {
    this.simuladorPlazo = 16;
    this.calcular();
  }

  private campoEsInvalido(valor: number): boolean {
    return valor < this.minValorSimulador || valor > this.maxValorSimulador;
  }

  private cotizar(monto: number, plazo: number): void {
    let multiplier: number;
    switch (plazo) {
      case 16:
        multiplier = 1.20672;
        break;
      case 20:
        multiplier = 1.25899;
        break;
      case 24:
        multiplier = 1.31264;
        break;
      case 28:
        multiplier = 1.36764;
        break;
      default:
        multiplier = 1.25899;
        break;
    }
    const totalAmount = monto * multiplier;
    const weeklyPayment = totalAmount / plazo;
    this.pagoSemanal = weeklyPayment;
    this.pagoTotal = totalAmount;
    this.pagoSemanalTexto = this.formatCurrency(weeklyPayment);
    this.pagoTotalTexto = this.formatCurrency(totalAmount);
  }

  calcular(): void {
    const monto = this.parseCurrency(this.simuladorMonto);
    const plazo = this.simuladorPlazo;
    if (this.campoEsInvalido(monto)) {
      this.pagoSemanal = 0;
      this.pagoTotal = 0;
      this.pagoSemanalTexto = '$0';
      this.pagoTotalTexto = '$0';
      return;
    }
    this.cotizar(monto, plazo);
  }

  scrollToFaq(event: Event, id: string): void {
    event.preventDefault();
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  goToClientForm(): void {
    const url = 'https://clientes.teu.mx/';
    window.open(url, '_blank', 'noopener');
    
  }

}
